import { createStyles, makeStyles, Theme } from '../../../MaterialUI'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: '445px',
      borderRadius: '16px',
    },
    input: {
      marginTop: '8px',
    },
    text: {
      color: theme.palette.primary.main,
      textAlign: 'center',
      background: '#FAFAFA',
      padding: '12px 24px',
      margin: '12px -24px 0',
    },
    center: {
      textAlign: 'center',
    },
    icon: {
      fontSize: theme.spacing(10),
      marginBottom: '16px',
    },
  })
)
